const Colors = {
    text: '#253834',
    textLighter: 'rgba(0,0,0,.6)',
};

export default Colors;
